export default "__VITE_ASSET__a332c929__"